import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import Title from 'components/Title/Title';
import { grid, setTypography } from 'utils/styles/mixins';
import { mediaDesktop, mediaTablet } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

export const Wrapper = styled(motion.div)`
  position: relative;
  min-height: calc(100dvh - min(106px, 10vh));
  color: ${colors.white};
  ${grid()}
  grid-template-rows: min-content auto;
  padding-bottom: 5vh;
  margin-top: 11vh;
  ${mediaTablet(css`
    margin-top: 8vh;
  `)}
`;

export const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
`;

export const Display = styled(Title)`
  ${setTypography('display')}

  margin-top: 5vh;
  grid-column: 2/-2;

  ${mediaDesktop(css`
    grid-column: 2/8;
  `)}

  margin-bottom: 1em;
`;

export const Content = styled.div`
  grid-column: 2/-2;

  h1,
  h2 {
    ${setTypography('heading2')}
    margin-bottom: 1em;
  }

  h3 {
    ${setTypography('heading3')}
    margin-bottom: 1em;
  }

  p,
  ul,
  ol {
    margin-bottom: 2em;
  }

  p:has(img) {
    margin: -2em 0 0 0;
  }

  p + h1,
  p + h2,
  p + h3 {
    margin-top: 2em;
  }
`;
